// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SecuredInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from './Izenda.Input';
import { omit } from 'lodash/fp';

export default class SecuredInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      secure: props.secure
    };
  }

  static propTypes = {
    value: PropTypes.string,
    secure: PropTypes.bool,
    enabled: PropTypes.bool,
    onChange: PropTypes.func,
    onReset: PropTypes.func
  };

  static defaultProps = {
    value: '',
    secure: false,
    enabled: true,
    onChange() {},
    onReset() {}
  };

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({
        value: nextProps.value,
        secure: nextProps.secure
      });
    }
  }

  reset = () => {
    const { props } = this;
    if (props.secure) {
      this.setState(
        {
          value: '',
          secure: false
        },
        function() {
          props.onReset && props.onReset();
        }
      );
    }
  };

  guardOnChange = e => {
    const { props, state } = this;
    if (!state.secure) {
      props.onChange(e);
    }
  };

  render() {
    const { props, state } = this;
    const rest = omit(['className', 'onChange', 'onReset', 'enabled', 'secure', 'value'], props);
    return (
      <Input
        autoComplete={'new-password'}
        className={props.className}
        type={state.secure ? 'password' : 'text'}
        onChange={this.guardOnChange}
        value={state.value}
        onFocus={this.reset}
        disabled={!props.enabled}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.SecuredInput.js